<div
  class="flex h-[min(90dvh,720px)] max-h-[90dvh] w-[min(100vw-2rem,900px)] flex-col overflow-hidden rounded-2xl bg-white shadow-xl">
  <div class="flex shrink-0 items-start justify-between gap-4 border-b border-neutral-200 px-5 py-4 sm:px-6">
    <div class="min-w-0">
      <h2 class="text-lg font-semibold text-slate-950">Add Members</h2>
      <p class="mt-1 text-sm text-slate-500">
        Add people from your contacts to {{ groupName }}
      </p>
    </div>
    <button
      type="button"
      class="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg text-lg text-slate-500 transition hover:bg-slate-100"
      aria-label="Close"
      (click)="close()">
      ×
    </button>
  </div>

  <div class="grid min-h-0 flex-1 grid-cols-1 divide-y divide-neutral-200 md:grid-cols-2 md:divide-x md:divide-y-0">
    <!-- Left: search + contacts -->
    <div class="flex min-h-0 flex-col">
      <div class="shrink-0 px-5 pt-4 sm:px-5">
        <lib-signal-text-field
          [inputType]="'search'"
          placeholder="Search people by name or email..."
          [prefixIcon]="'assets/icons/search.svg'"
          [value]="search()"
          [debounceValueChange]="true"
          (valueChange)="onSearchChange($event)" />
      </div>

      <div class="min-h-0 flex-1 overflow-y-auto px-3 py-3 sm:px-4">
        @if (listState.loading() && contacts().length === 0) {
          <p class="py-8 text-center text-sm text-neutral-500">
            Loading contacts…
          </p>
        } @else if (contacts().length === 0) {
          <p class="py-8 text-center text-sm text-neutral-500">
            No contacts found.
          </p>
        } @else {
          <ul class="flex flex-col gap-0.5">
            @for (contact of contacts(); track contact.id) {
              <li class="flex items-center gap-3 rounded-xl px-2 py-2.5 transition hover:bg-neutral-50">
                <div
                  class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-caption font-semibold text-white"
                  [ngClass]="avatarColor(contact.id)"
                  aria-hidden="true">
                  {{ initials(contact) }}
                </div>
                <div class="min-w-0 flex-1">
                  <p class="truncate text-sm font-medium text-neutral-900">
                    {{ displayName(contact) }}
                  </p>
                  <p class="truncate text-xs text-neutral-500">
                    {{ contact.email }}
                  </p>
                </div>
                @if (isMember(contact.id)) {
                  <span class="shrink-0 px-2 text-sm font-medium text-neutral-400">
                    Added
                  </span>
                } @else {
                  <lib-signal-button
                    size="sm"
                    iconSrc="assets/icons/plus.svg"
                    [fullWidth]="false"
                    [disabled]="isPending(contact.id)"
                    [loading]="isPending(contact.id)"
                    (clicked)="addMember(contact)">
                    Add
                  </lib-signal-button>
                }
              </li>
            }
          </ul>
        }
      </div>

      @if (totalCount() > 0) {
        @for (_ of [paginationKey()]; track _) {
          <div class="shrink-0">
            <app-pagination
              type="compact"
              [totalItems]="totalCount()"
              [pageSize]="pageSize()"
              [pageSizeOptions]="[10, 20, 50]"
              (pageChange)="onPageChange($event)" />
          </div>
        }
      }
    </div>

    <!-- Right: members -->
    <div class="flex min-h-0 flex-col bg-neutral-50/60">
      <div class="flex shrink-0 items-center justify-between gap-3 px-5 py-4">
        <h3 class="text-sm font-semibold text-slate-950">
          Members ({{ memberCount() }})
        </h3>
      </div>

      <div class="min-h-0 flex-1 overflow-y-auto px-5 pb-4">
        @if (members().length === 0) {
          <p class="py-8 text-center text-sm text-neutral-500">
            Add people from the list.
          </p>
        } @else {
          <ul class="flex flex-col gap-2">
            @for (contact of members(); track contact.id) {
              <li
                class="flex items-center gap-3 rounded-xl border border-neutral-200 bg-white px-3 py-2.5">
                <div
                  class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-caption font-semibold text-white"
                  [ngClass]="avatarColor(contact.id)"
                  aria-hidden="true">
                  {{ initials(contact) }}
                </div>
                <div class="min-w-0 flex-1">
                  <p class="truncate text-sm font-medium text-neutral-900">
                    {{ displayName(contact) }}
                  </p>
                  <p class="truncate text-xs text-neutral-500">
                    {{ contact.email }}
                  </p>
                </div>
                <button
                  type="button"
                  class="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg text-neutral-400 transition hover:bg-neutral-100 hover:text-neutral-700 disabled:cursor-not-allowed disabled:opacity-50"
                  aria-label="Remove from group"
                  [disabled]="isPending(contact.id)"
                  (click)="removeMember(contact)">
                  ×
                </button>
              </li>
            }
          </ul>
        }
      </div>
    </div>
  </div>

  <div
    class="flex shrink-0 justify-end border-t border-neutral-200 px-5 py-4 sm:px-6">
    <lib-signal-button [fullWidth]="false" (clicked)="done()">
      Done
    </lib-signal-button>
  </div>
</div>
